import React from 'react';
import PropTypes from 'prop-types';

const InquiryData = ({ label, value }) => (
  <div className="inquiry-data mb-5 w-1/2">
    <p className="inquiry-data-label text-gray-500 font-bold text-xs">
      {label}
    </p>
    {value && <p className="inquiry-data-value font-medium text-sm break-all">
      {value}
    </p>}
    {!value && <div className="w-full h-auto max-w-75 justify-start flex">
      <div className="h-4 bg-gray-300 w-10/12 mr-2"></div>
      <i className="fa fa-question-circle" aria-hidden="true"></i>
    </div>}
  </div>
);

InquiryData.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

export default InquiryData;
